/**
 * @fileoverview NotesPanel Component
 * 
 * A note-taking component for use during telehealth meetings.
 * Provides a full-height textarea with custom styling that fits
 * within the meeting interface.
 * 
 * Features:
 * - Full-height textarea that adjusts to available space
 * - Custom styling with semi-transparent background
 * - Event propagation prevention to avoid conflicts with meeting controls
 * - Responsive design that works with the meeting layout
 * 
 */

import React from "react";

import { Stack } from "@mui/material";


const NotesPanel: React.FC = () => {
  // State to store the notes content
  const [notes, setNotes] = React.useState<string>("");

  // Inline styles for the textarea to ensure proper integration with the meeting UI
  const textareaStyle = {
    display: "flex",
    width: "100%",
    height: "calc(100vh - 106px)", // Adjust for AppBar and padding
    border: "none",
    resize: "none" as const,
    borderRadius: "5px",
    padding: "5px",
    background: "rgba(255, 255, 255, 0.2)", // Semi-transparent white background
    color: "#fff",
  };

  return (
    <>
      {/* Custom CSS for placeholder styling */}
      <style>
        {`
          .notes-textarea::placeholder {
            color: #fff;
            opacity: 0.7;
          }
        `}
      </style>
      
      {/* Container with consistent padding */}
      <Stack
        sx={{
          padding: 2,
          pr: 3, // Extra right padding for better visual balance
        }}
      >
        {/* Main notes textarea */}
        <textarea
          className="notes-textarea"
          placeholder="Notes..."
          cols={40}
          style={textareaStyle}
          onMouseDown={(e) => e.stopPropagation()} // Prevent interference with meeting controls
          value={notes}
          onChange={(event) => setNotes(event.target.value)}
        />
      </Stack>
    </>
  );
};

export default NotesPanel;
